import { createContext, useContext } from "react";
import type { SaveGroup } from "../lib/steps";

export type LeaveRequest = {
  groups: SaveGroup[];
  /** Step moves keep the draft so Finish can show it as unsaved; exiting the wizard drops it. */
  discard: boolean;
  action: () => void;
};

export type UnsavedChangesValue = {
  requestStep: (index: number) => void;
  requestHub: () => void;
};

export const UnsavedChangesContext = createContext<UnsavedChangesValue | null>(
  null,
);

export function useUnsavedChanges(): UnsavedChangesValue {
  const value = useContext(UnsavedChangesContext);
  if (!value) {
    throw new Error(
      "useUnsavedChanges must be used within UnsavedChangesProvider",
    );
  }
  return value;
}
